import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    messages: {},
    unreaded: {}
  },

  mutations: {
    setMessages (state, { list, memberId }) {
      const messages = { ...state.messages }
      messages[memberId] = list
      state.messages = messages
    },
    setUnread (state, { list }) {
      state.unreaded = list
    }
  },
  getters: {
    hasUnread (state) {
      return Object.values(state.unreaded).length > 0
    }
  },
  actions: {
    getMessages ({ commit, state, dispatch }, memberId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.getCampaignMessages(token, memberId)
              .then((res) => {
                commit('setMessages', { list: res.body, memberId })
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    },
    addMessage ({ commit, state, dispatch }, { memberId, message }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.addCampaignMessages(token, memberId, message)
            .then((res) => {
              dispatch('getMessages', memberId)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    markAsReaded ({ commit, state, dispatch }, memberId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.markAsReadedCampaignMessage(token, memberId)
            .then((res) => {
              dispatch('getMessages', memberId)
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getUnread ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getUnread(token)
            .then((res) => {
              commit('setUnread', { list: res.body })
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
